import { fetchAgents, selectAgent, resetCurrentAgent } from '../../actions/agents_actions';
import { connect } from 'react-redux';

import Agents from '../../components/Agents/agents'

function mapStateToProps(state) {
    return {
        agents: state.agents.all,
        currentAgent: state.agents.currentAgent,
        isLoading: state.agents.isLoading,
        error: state.agents.error,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { fetchAgents, selectAgent, resetCurrentAgent })(Agents);



// WEBPACK FOOTER //
// ./master/jsx/containers/Agents/agents.jsx